const routes = [
  {
    path: '/customerServiceEntry', // 客服录入主页面
    name: 'customerServiceEntry',
    component: () => import('@src/modules/customerServiceEntry/main'),
    redirect: '/customerServiceEntry/index',
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'index', // 客服录入列表界面
        name: 'index',
        component: () => import('@src/modules/customerServiceEntry/view/entry'),
        meta: {
          requireAuth: true,
          routerAlive: true
        }
      },
    ]
  },
]

export default routes
